import { render, staticRenderFns } from "./hbPage.vue?vue&type=template&id=3bea9494&scoped=true&"
import script from "./hbPage.vue?vue&type=script&lang=js&"
export * from "./hbPage.vue?vue&type=script&lang=js&"
import style0 from "./hbPage.vue?vue&type=style&index=0&id=3bea9494&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea9494",
  null
  
)

export default component.exports